export default __webpack_public_path__ + "static/investment-3a8d9b95c426456d8aeb2b5d9c724f3f.png";